<table mat-table [dataSource]="dataSource" class="table employee-list no-wrap" multiTemplateDataRows>
    <ng-container [matColumnDef]="column.name" *ngFor="let column of displayedColumns">
        <ng-container *ngIf="!column.custom; else customTemplates">
            <th mat-header-cell *matHeaderCellDef>
                <strong>{{ column.label }}</strong>
            </th>
            <td mat-cell *matCellDef="let element">{{ getPropertyValue(element, column.name) }}</td>
        </ng-container>
        <ng-template #customTemplates>
            <ng-container [ngTemplateOutlet]="column.name === 'actions' ? actions : other"></ng-container>

            <ng-template #actions>
                <th mat-header-cell *matHeaderCellDef>
                    <strong>{{ column.label }}</strong>
                </th>
                <td mat-cell *matCellDef="let element">
                    <button
                        mat-icon-button
                        aria-label="Expandir"
                        (click)="toggleRow(element); $event.stopPropagation()"
                    >
                        <mat-icon>{{
                            expandedElement === element ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                        }}</mat-icon>
                    </button>
                </td>
            </ng-template>

            <ng-template #other>
                <th mat-header-cell *matHeaderCellDef>Otra</th>
                <td mat-cell *matCellDef="let element">Otra columna</td>
            </ng-template>
        </ng-template>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
            <div [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                <div class="p-15 rounded b-1 m-b-16 m-x-18">
                    <div class="f-s-14 m-t-8">
                        <mat-chip-list aria-label="Errores">
                            <mat-chip *ngFor="let error of element.errors">
                                {{ error }}
                                <mat-icon matChipRemove style="color: red">report</mat-icon>
                            </mat-chip>
                        </mat-chip-list>
                    </div>
                </div>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
        mat-row
        *matRowDef="let row; columns: columnsToDisplay"
        [class.example-expanded-row]="expandedElement === element"
        class="example-element-row"
    ></tr>
    <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="example-detail-row"
        [style.display]="expandedElement === row ? 'table-row' : 'none'"
    ></tr>
</table>

<mat-paginator [pageSize]="pageDefaultSize" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
